/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.professional-development.approval-areas'},
});

const ApprovalAreasItem = () => (
  <RouteLinkItem
    route="midas/settings/professional-development/approval-areas"
    title={messages.title}
  />
);

export default ApprovalAreasItem;
